import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { StyledOktaRedirectWrapper } from './Styles';
import OktaAuthManagementService from '../../services/OktaAuthManagementService';

const OktaRedirect = () => {
  useEffect(() => {
    const oktaService = OktaAuthManagementService.get();
    oktaService.initiateOktaSession(true);
  }, []);

  return (
    <StyledOktaRedirectWrapper>
      <div className="form-wrapper">
        <span className="redirect">
          <FormattedMessage id="okta.redirect.loading" />
        </span>
      </div>
    </StyledOktaRedirectWrapper>
  );
};

export default OktaRedirect;
